import React from 'react';
import Select from 'react-select'
import { Form, Col, Row, Container } from 'react-bootstrap';

export const ManufacturerMultiSelect = ({ manufacturers, defaultManufacturerId, handleManufacturersChanged }) => {
    if (!manufacturers || !manufacturers.length) {
        return null;
    }

    const options = manufacturers.map(m => {
        return {
            value: m.id.toString(),
            label: m.name
        }
    });

    const defaultValue = defaultManufacturerId
        ? options.filter(o => o.value === defaultManufacturerId)
        : null;

    return (
        <Container>
            <Form onSubmit={(event) => event.preventDefault()}>
                <Form.Group as={Row} controlId="sectionForm.SectionSelect">
                    <Form.Label column sm="2" md={50}>
                        Manufacturers:
                    </Form.Label>
                    <Col sm="10" md="100%">
                        <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            defaultValue={defaultValue}
                            onChange={(selectedOptions) => {
                                const mfgs = selectedOptions
                                    ? selectedOptions.map(option => {
                                        return {
                                            id: option.value,
                                            name: option.label
                                        }
                                    }) : null;

                                handleManufacturersChanged(mfgs);
                            }}
                            isMulti
                            options={options} />
                    </Col>
                </Form.Group>
            </Form>
        </Container>
    );
}
